import*as t from"react";import{IconsContext as o}from"./IconsContext.mjs";function r(r){const n=t.useContext(o);if(r&&n)return n[r]}export{r as useIcons};
